import React from 'react';

import Button from '@dashboard/components/Button';
import CreateWithAIButton from '@dashboard/components/CreateWithAIButton';
import PageHeader from '@dashboard/components/PageHeader';
import PagesList from '@dashboard/components/PagesList';

const emptyState = {
  searchTitle: 'No forms found',
  filteredTitle: 'No forms found',
  defaultTitle: 'Create your first form',
  defaultSubtitle: 'Capture leads and collect feedback.',
  createLabel: 'Create form',
};

const Forms = () => {
  return (
    <>
      <div className="p-4 space-y-4">
        <PageHeader
          title="Forms"
          topBarActions={
            <div className="flex items-center gap-2">
              <CreateWithAIButton pageType="form" />

              <Button to="/forms/new" appearance="primary">
                Create form
              </Button>
            </div>
          }
        />

        <PagesList
          type="form"
          emptyState={emptyState}
          createHref="/forms/new"
          searchPlaceholder="Search forms"
        />
      </div>
    </>
  );
};

export default Forms;
